<template>
    <div class="chart-container">
        <div id="chartModel" ref="chartModelRef" oncontextmenu="return false;"></div>
        <div class="jump-model" v-show="showBtn" ref="btnModelRef">
            <!-- 验证规则：name的长度小于6（620102这种就是最下级了）,而且由于系统默认的顶级是中文（服装等），所以需要做判断 -->
            <!-- v-show="currentNode.name && (titleList.includes(currentNode.name) || currentNode.name.length < 6)"> -->
            <!-- 20240717 tree层级改变最多五层   所有只有小于等于第四层才可以添加子集 -->
            <div v-permit="'hscode.add'" class="btn-style" @click="handlerJump('add')" v-show="currentNode.level <= 4">
                <i class="ri-add-circle-fill common-icon"></i>
                <span>{{
                   getLangValue("hscode.createProductsAtThisLevel")
                }}</span>
            </div>
            <div v-permit="'hscode.show'" class="btn-style my-1" @click="handlerJump('view')">
                <i class="ri-eye-fill common-icon"></i>
                <span>{{ getLangValue("base.viewDetails") }}</span>
            </div>
            <div class="btn-style" @click="handlerJump('cancel')">
                <i class="ri-close-circle-fill common-icon"></i>
                <span>{{ getLangValue("base.cancel") }}</span>
            </div>
        </div>
        <!-- hscode详情 -->
        <div class="offcanvas offcanvas-end border-0 my-scroll-bar" style="max-height: 820px; top: 80px; overflow-y: auto;"
            tabindex="-1" id="theme-settings-offcanvas">
            <div class="offcanvas-body p-0 my-scroll-bar" >
                <SimpleBar class="h-100">
                    <div class="p-4">
                        <hscodeDetail :titleList="titleList" :selectedObj="selectedObj" :typeList="typeList"
                            @updateTree="updateTree" />
                    </div>
                </SimpleBar>
            </div>
        </div>
        <button ref="viewDetailBtnRef" class="btn-info btn-rounded shadow-lg btn btn-icon btn-lg p-2"
            style="display: none" data-bs-toggle="offcanvas" data-bs-target="#theme-settings-offcanvas"
            aria-controls="theme-settings-offcanvas"></button>
    </div>
</template>
<script setup>
import { ref, onMounted, defineExpose, defineProps, toRefs, defineEmits } from "vue"
import * as echarts from 'echarts';
import hscodeDetail from "./hscodeDetail.vue"
import { treeToFlat } from "@/utils/common"
import i18n from "@/i18n"
import { getHscodeDetail } from "@/service"
import { useRouter } from "vue-router"
import { getLangValue } from "@/utils/common"; //获取后端语言
const chartModelRef = ref(null);
const btnModelRef = ref(null);
const viewDetailBtnRef = ref(null);
// import randomColor from 'randomcolor'
const myChart = ref('')
const type = ref('')
const showBtn = ref(false);
const props = defineProps({
    typeList: {
        type: Array,
        required: true,
    },
})
const emits = defineEmits(["updateTreeData", "updateChartData",])
const selectedObj = ref({})
const router = useRouter()
// const route = useRoute()
const currentNode = ref({})
const { typeList } = toRefs(props);
// 顶级的文字  可以自己写死 或者 自己从树里获取
const titleList = i18n.global.locale == 'ch' ? ["服装", "织物", "纱线", "纤维", "床上用品", "普通家用纺织品", "产业纺织品", "厨卫用品"] :
    ["Garment", "Fabric", "Yarn", "Fiber", "Bedding", "Household Textiles", "Industrial Textiles", "Kitchen and Bathroom Supplies"];
// const titleList = ref([])
const handlerJump = async (type) => {
    //图表dom菜单操作
    //add 跳转到表单页面
    //view 弹出详情页面框
    switch (type) {
        case 'add':
            router.push({
                name: "hscode_management_detail",
                query: {
                    parentId: currentNode.value.id,
                    type: 'add',
                    showIndex: 0
                }
            })
            break;
        case 'view':
            showBtn.value = false;
            await gethscodeDetail(currentNode.value.id)
            // 获取数据
            viewDetailBtnRef.value.click();
            break;
        case 'cancel':
            showBtn.value = false;
            break;
        default:
            break;
    }
}

const gethscodeDetail = async (id) => {
    //获取hscode详情信息
    const resp = await getHscodeDetail(id);
    if (resp.payload !== null) {
        selectedObj.value = resp.payload;
    }
}

const updateTree = () => {
    //更新树
    emits('updateTreeData');
}
const showBtnList = (options) => {
    //显示dom菜单 已经设置位置
    const { x, y, name, id, level } = options
    currentNode.value = {
        id: id,
        name: name,
        level: level
    }
    btnModelRef.value.style.left = `${x + 15}px`;
    btnModelRef.value.style.top = `${y + 15}px`;
    showBtn.value = true;
}
const changeType = () => {
    //切换图表类型
    let arr = typeList.value.filter(item => item.id === type.value)
    const data = treeToFlat(arr, 'parentId')
    console.log(data.links.length);
    initCharts(data)
}
// const generateRandomPoint = (level) => {
//     // level =2 10 levl==3 100 levle=4 1000  level=4 10000
//     // 生成一个在 [0, 2π) 范围内的随机角度
//     // const theta = Math.random() * 3 * Math.PI;
//     let x, y;
//     // 计算对应的 x 和 y 值
//     if (level == 2) {
//         x =  Math.random() < 0.5 ? Math.floor(Math.random(0,50)* 50) * -1 :  Math.floor(Math.random(0,50)* 50);
//         y = Math.random() < 0.5 ? Math.floor(Math.random(0,50)* 50)* -1 :  Math.floor(Math.random(0,50)* 50) ;
//     } else if (level == 3) {
//         x =  Math.random() < 0.5 ? getRandomInt(0,200) * -1 :  getRandomInt(0,200);
//         y = Math.random() < 0.5 ? getRandomInt(50,200) * -1 :  getRandomInt(50,200);
//     } else if (level == 4) {
//         x =  Math.random() < 0.5 ? getRandomInt(0,400) * -1 :  getRandomInt(0,400);
//         y = Math.random() < 0.5 ? getRandomInt(100,400) * -1 :  getRandomInt(100,400);
//     } else if (level == 5) {
//         x =  Math.random() < 0.5 ? getRandomInt(200,300) * -1 :  getRandomInt(200,300);
//         y = Math.random() < 0.5 ? getRandomInt(200,300) * -1 :  getRandomInt(200,300);
//     }
//     return { x, y };
// }
// function getRandomInt(min, max) {
//   min = Math.ceil(min); // 确保min是整数
//   max = Math.floor(max); // 确保max是整数
//   return Math.floor(Math.random() * (max - min + 1)) + min; // 返回介于min和max之间的整数
// }

// const setXy = (data) => {
//     // 画圆 半径100
//     for (var i = 0; i < data.length; i++) {
//         const { x, y } = generateRandomPoint(data[i].level);
//         data[i].x = data[i].level == 1 ? 0 : x; // 水平方向上的位置，这里是每个节点之间间隔100个像素
//         data[i].y = data[i].level == 1 ? 0 : y; // 垂直方向上的位置，这里是0到100之间的随机数
//     }
//     // console.log(data);
//     return data
// }
const initCharts = async ({ nodeData, links }, text) => {
    /**node配置了id  则source target也必须用id */
    // console.log(nodeData, links);
    const repulsion = () => {
        if (links.length < 5) {
            return 800
        } else {
            return 500
        }
    }
    // console.log(nodeData);
    // var option12 = {
    //     color: ["#7998e4"],
    //     series: [{
    //         type: 'graph',
    //         layout: 'none',  // No automatic layout, positions must be specified manually
    //         roam: true,      // Enable mouse zooming and translating
    //         symbolSize: (_data, params) => {
    //             //根据数据params中的data来判定数据大小
    //             // console.log(params);  50 45 30 20 20
    //             let symbolSize = (params.data.value) * 0.3
    //             return symbolSize
    //         },// Node size
    //         legendHoverLink: false,
    //         // edgeSymbol: ['circle', 'arrow'],
    //         // edgeSymbolSize: [4, 10],
    //         // edgeLabel: {
    //         //     fontSize: 20
    //         // },
    //         data: setXy(nodeData),
    //         links: links,
    //         label: {
    //             show: true,
    //             color: '#000',
    //             position: 'bottom'
    //         },
    //         lineStyle: {
    //             color: 'source',
    //             curveness: 0.3
    //         },
    //         emphasis: {
    //             focus: 'adjacency',
    //             lineStyle: {
    //                 width: 10
    //             }
    //         }
    //     }]
    // };
    let option = {
        containLabel: true,
        // color: randomColor({
        //     luminosity: 'light',
        //     hue: 'blue'
        // }),
        color: ["#7998e4"],
        animation: false,
        // animation: {
        //     update: {
        //         // 配置布局动画
        //         layoutAnimation: 'force'
        //     }
        // },
        series: [
            {
                name: "模型基础类型",
                type: "graph",
                layout: "force",
                focusNodeAdjacency: true,//是否在鼠标移到节点上的时候突出显示节点以及节点的边和邻接节点。
                selectedMode: true,
                animation: false,
                // animationDuration: function (idx) {
                //     // 越往后的数据时长越大
                //     return idx * 2;
                // },
                symbolSize: (_data, params) => {
                    //根据数据params中的data来判定数据大小
                    // console.log(params);  50 45 30 20 20
                    let symbolSize = (params.data.value) * 0.5
                    return symbolSize
                },
                select: {
                    itemStyle: {
                        borderWidth: 3,
                        borderColor: '#C3A35B'
                    }
                },
                force: {
                    repulsion: repulsion(),
                    edgeLength: 5,
                    gravity: 0.5,
                    // initLayout: null,
                    // friction: 0.6,
                    layoutAnimation: false //节点超过100 设置为false 浏览器就会卡死
                },
                data: nodeData,
                edges: links,
                // categories: data.categories,
                roam: true,
                emphasis: {
                    focus: 'adjacency',
                    scale: 1.2,
                    itemStyle: {
                        borderWidth: 1.5,
                        borderColor: '#C3A35B'
                    }
                },
                label: {
                    show: true,
                    color: '#000',
                    position: 'bottom'
                },
                lineStyle: {
                    curveness: 0.3,
                    color: 'source',
                    width: 2
                },
            },
        ]
    };
    // console.log(nodeData)
    // console.log(links.length)
    // 初始化图表
    if (!myChart.value)
        myChart.value = echarts.init(chartModelRef.value);
    if (nodeData.length > 100 || links.length > 100) {
        option.series[0].force.layoutAnimation = true;
    } else {
        option.series[0].force.layoutAnimation = false;
    }
    myChart.value.setOption(option);
    // text选中
    if (text) {
        let dataIndex = nodeData.findIndex(item => item.name === text)
        console.log(dataIndex);
        if (dataIndex > -1) {
            myChart.value.dispatchAction({
                type: 'focusNodeAdjacency',
                // 节点名称
                seriesIndex: 0,
                dataIndex: dataIndex // 节点1在 data 数组中的索引
            });
            var option1 = myChart.value.getOption();
            option1.series[0].data[dataIndex].itemStyle = {
                borderWidth: 3,
                borderColor: '#C3A35B'
            };
            myChart.value.setOption(option1);
        }

    }
    // if (links.length > 80) {
    //     let links1 = links.slice(0, 80);
    //     let data1 = nodeData.slice(0, 80);
    //     option.series[0].edges = links1;
    //     option.series[0].data = data1;
    //     myChart.value.setOption(option);
    //     let i = 80;
    //     let timer = null;
    //     timer = setInterval(function () {
    //         console.log(i)
    //         if (i == links.length - 1) {
    //             clearInterval(timer);
    //             return
    //         }
    //         myChart.value.setOption({
    //             series: [
    //                 {
    //                     roam: true,
    //                     data: nodeData.slice(0, i+1),
    //                     edges: links.slice(0, i+1)
    //                 }
    //             ]
    //         });
    //         i += 1;
    //     }, 2000);
    // } else {
    //     // option.series[0].force.layoutAnimation = false;
    //     // 应用配置
    //     myChart.value.setOption(option);
    // }



    //图表点击事件
    // let clickTimer;
    myChart.value.on('click', (node) => {
        // 清除可能存在的双击事件定时器
        // clearTimeout(clickTimer);

        // 设置单击事件的定时器
        // clickTimer = setTimeout(function () {
        // console.log(node);
        // 处理单击事件
        let options = {
            x: node.event.event.offsetX,
            y: node.event.event.offsetY,
            name: node.name,
            id: node.data.id,
            level: node.data.level
        }
        //显示弹框
        showBtnList(options)
        // }, 300);

        // 获取该node下的children
        // emits('updateChartData', node.data.id)
    })
    // myChart.value.on('dblclick', (node) => {
    //     clearTimeout(clickTimer);
    //     // 获取该node下的children
    //     emits('updateChartData', node.data.id)
    // })

}
const resizeChart = () => {
    if (myChart.value)
        myChart.value.resize();
}
onMounted(() => {
    // initCharts();
    window.addEventListener('resize', resizeChart);
})

// watch(typeList, (val)=> {
//     //tree结构获取顶级类型  中英文
//     // titleList.value =val.map(item=> item.title)
// })
//弹出initCharts  通过ref调用
defineExpose({
    initCharts,
    myChart,
    type,
    changeType
})
</script>
<style scoped>
.chart-container {
    width: 100%;
    height: 100%;
    position: relative;

    #chartModel {
        width: 100%;
        height: 100%;
    }

    .jump-model {
        position: absolute;
        background-color: #fff;
        padding: 10px;
        border-radius: 5px;

        .btn-style {
            display: flex;
            align-items: center;

            .common-icon {
                color: #2C404C;
                margin-right: 5px;
            }

            &:hover {
                cursor: pointer;
                background-color: #f3f6f9;
            }
        }
    }

    .offcanvas-end {
        width: 75%;
    }

    .text-g {
        color: #4c5461;
    }

    .offcanvas.showing,
    .offcanvas.hiding,
    .offcanvas.show {
        left: 12%;
    }

    :deep .offcanvas-backdrop {
        /* z-index: 2100 !important; */
        /* swal2弹框-index：1060 */
        z-index: 1059 !important;
    }

    .offcanvas {
        /* z-index: 2101 !important; */
        z-index: 1059 !important;
    }
}
</style>